import React, { createContext, useState, useContext } from "react";

// Create a context for Dark Mode
const DarkModeContext = createContext();

// Dark Mode Provider Component
const DarkModeProvider = ({ children }) => {
  // State to manage dark mode
  const [darkMode, setDarkMode] = useState(false);

  // Function to toggle dark mode
  const toggleDarkMode = () => {
    setDarkMode((prevMode) => !prevMode);
  };

  // Provide dark mode state and toggle function to children components
  return (
    <DarkModeContext.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
};

// Custom Hook to use the Dark Mode context
const useDarkMode = () => {
  const context = useContext(DarkModeContext);

  // Throw an error if the hook is used outside of a DarkModeProvider
  if (!context) {
    throw new Error("useDarkMode must be used within a DarkModeProvider");
  }

  return context;
};

export { DarkModeProvider, useDarkMode };
